import ACTIONS from '../actionTypes/publish'
import PublishService from '../../services/PublishService'

export const publishToPlatforms = (releaseId, platfromIds) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_PUBLISH_TO_PLATFORMS })

    return PublishService.publishToPlatforms(releaseId, platfromIds).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.PUBLISH_TO_PLATFORMS_SUCCESS, payload: res.data })
        return res.data
      } else {
        dispatch({ type: ACTIONS.PUBLISH_TO_PLATFORMS_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.PUBLISH_TO_PLATFORMS_FAILED })
    })
  }
}

export const getApplicationReleasePlatforms = (releaseId) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_GET_APPLICATION_RELEASE_PLATFORMS })

    return PublishService.getApplicationReleasePlatforms(releaseId).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.GET_APPLICATION_RELEASE_PLATFORMS_SUCCESS, payload: res.data })
      } else {
        dispatch({ type: ACTIONS.GET_APPLICATION_RELEASE_PLATFORMS_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.GET_APPLICATION_RELEASE_PLATFORMS_FAILED })
    })
  }
}

export const getPlatformSettings = (releaseId, platformId) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_GET_PLATFORM_SETTINGS })

    return PublishService.getPlatformSettings(releaseId, platformId).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.GET_PLATFORM_SETTINGS_SUCCESS, payload: res.data })
      } else {
        dispatch({ type: ACTIONS.GET_PLATFORM_SETTINGS_FAILED })
      }
    }).catch((error) => {
      // If not found (404), return empty object to payload
      if (error?.status === 404) {
        dispatch({ type: ACTIONS.GET_PLATFORM_SETTINGS_SUCCESS, payload: null })
        return
      }
      dispatch({ type: ACTIONS.GET_PLATFORM_SETTINGS_FAILED })
    })
  }
}

export const addOrUpdatePlatformSettings = (ids, platformSettings) => {
  return (dispatch) => {
    dispatch({ type: ACTIONS.START_ADD_OR_UPDATE_PLATFORM_SETTINGS })

    return PublishService.addOrUpdatePlatformSettings(ids, platformSettings).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.ADD_OR_UPDATE_PLATFORM_SETTINGS_SUCCESS, payload: res.data })
        return res.data
      } else {
        dispatch({ type: ACTIONS.ADD_OR_UPDATE_PLATFORM_SETTINGS_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.ADD_OR_UPDATE_PLATFORM_SETTINGS_FAILED })
    })
  }
}
